import { AppointmentEnrollmentResult } from "@/data/appointments";
import { EnrollmentCriteriaError } from "@/data/enrollments";

export function parseEnrollmentErrorResult(data: AppointmentEnrollmentResult): string|null {
    try {
        const appointmentErrors = parseEnrollmentErrorResultHighestErrors(data?.appointment?.errors || []).map(error => error.errorMessage) || [];
        const courseErrors = parseEnrollmentErrorResultHighestErrors(data?.course?.errors || []).map(error => error.errorMessage) || [];

        return [...appointmentErrors, ...courseErrors].join(' / ') || null;
    }
    catch( e ) {
        console.error('error in parseEnrollmentErrorResult()', e, 'data:', JSON.stringify(data, null, 2));
        return null;
    }
}

function parseEnrollmentErrorResultHighestErrors(errors: EnrollmentCriteriaError[]) : EnrollmentCriteriaError[] {
    // .filter(error => !tag || error.tags.includes(tag))
    return errors.reduce<EnrollmentCriteriaError[]>((list, error) => {
        if( list.length < 1 ) {
            return [error];
        }
        const max = list[0].priority; // list will only contain entries of the same priority at all times, so use first entry
        if( error.priority > max ) {
            return [error]; // new max priority found
        }
        if( error.priority === max ) {
            return [...list, error]; // same max priority, so append
        }
        return list;
    }, []);
}
